Vue.component('epg-list-image', {

    props: ['program'],

    methods: {
        showImage()
        {
            if (!this.program.obrazek) return;

            let from = moment(this.program.od).unix();
            let to =  moment(this.program.do).unix();

            return (to - from > 2700);
        },
    },

    template:
`
<div v-if="showImage()" class="mr-3">
    <img v-bind:src="program.obrazek" alt="Obrázek" v-bind:title="program.nazev" draggable="false">
</div>
`
});


Vue.component('epg-detail', {

    props: ['program', 'tv'],

    filters: {
        time: function (val) {
            return moment(val).format("HH:mm")
        },
        date: function (val) {
            let mmnt = moment(val);
            return mmnt.isSame(moment(), 'day') ? 'dnes' : moment(val).format("dddd D.M.");
        },
    },

    template:
`
<div v-if="program">

    <div class="modal fade epg-detail" tabindex="-1" role="dialog" id="detailModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <div class="d-flex flex-column flex-md-row">
                        <div class="epg-detail-image d-none d-md-block mb-3 mb-md-0"><img v-bind:src="program.obrazek" alt="Obrázek" v-bind:title="program.nazev" class="d-block m-auto"></div>
                        <div class="epg-detail-content px-md-3">
                            <div>
                                <h2 class="mb-3">{{program.nazev}}</h2>
                            </div>
                            <div class="d-flex flex-row mb-3 ff700 fsz-sx-12 text-center text-md-left">
                                <div>{{tv.tv_name}}</div>
                                <div class="text-capitalize delimiter-left">{{program.od|date}}</div>
                                <div class="delimiter-left">{{program.od|time}} - {{program.do|time}}</div>
                                    <div v-if="program.delka" class="delimiter-left">{{program.delka}} min.</div>
                                <div v-if="program.typprg" class="delimiter-left">{{program.typprg}}</div>
                            </div>
                            <div>
                                <div class="clearfix">
                                    <p v-if="program.dlouhypopis">
                                        <img v-bind:src="program.obrazek" alt="Obrázek" v-bind:title="program.nazev" class="epg-detail-sm-image d-md-none">
                                        {{program.dlouhypopis}}
                                    </p>
                                    <p v-if="!program.dlouhypopis && program.kratkypopis">
                                        <img v-bind:src="program.obrazek" alt="Obrázek" v-bind:title="program.nazev" class="epg-detail-sm-image d-md-none">
                                        {{program.kratkypopis}}
                                    </p>
                                </div>
                                <hr v-if="program.rezie || program.hraji || program.zeme || program.rok">
                                <p v-if="program.rezie" class="mb-1"><span class="ff700">Režie: </span> {{program.rezie}}</p>
                                <p v-if="program.hraji" class="mb-1"><span class="ff700">Hrají: </span> {{program.hraji}}</p>
                                <p v-if="program.zeme" class="mb-1"><span class="ff700">Země původu: </span> {{program.zeme}}</p>
                                <p v-if="program.rok" class="mb-1"><span class="ff700">Rok vydání: </span> {{program.rok}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
`
});


/*!
 *
 * EPG app
 */

let epgApp = new Vue({

    el: '#epg',

    data: {
        loading: false,
        expanded: false,
        dataUrl: '/epg/data/?date=',
        epg: [],
        epgDate: moment(),
        prevDayAvailable: false,
        nextDayAvailable: false,
        hourWidth: 400,
        minuteWidth: 400 / 60,
        timeLine: [],
        timeLineScrollLeft: 0,
        timeLineEl: null,
        time: moment(),
        timeFormatted: moment().format("H:mm:ss"),
        timeDelimiterStyles: {},
        dragMoveAvailable: false,
        dragMoveX: 0,
        dragMoveY: 0,
        dragMoveClassName: "",
        topBarSticky: false,
        programDetail: null,
        tvDetail: null,
        openDetailAvailable: Date.now(),
        mouseOverTv: '',
        scrollVerticalInterval: null,
        lang: typeof templateLang !== 'undefined' ? templateLang : 0,  // 0 CS_CZ, 1 SK_sk
        t: {
            prevDay: ["předchozí den", "predchádzajúci deň"],
            now: ["nyní", "teraz"],
            nextDay: ["další den", "ďalší deň"],
        }
    },

    methods: {

        getData(programDate)
        {

            if (this.loading) return;

            this.loading = true;

            this.$http.get(this.dataUrl + programDate, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                    'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }).then(response => {
                if (response.body.success) {
                    if (!response.body.success) return;

                    this.epg = response.body.data;
                    this.prevDayAvailable = response.body.prevDay;
                    this.nextDayAvailable = response.body.nextDay;
                    this.afterGetProgramData();

                    console.log(this.epg)

                    this.loading = false;
                }
            }, response => {
                console.log('getRecords: Error', response.status);
            });
        },

        afterGetProgramData()
        {
            setTimeout(() => {
                this.setTimeDelimiterStyles();
                if (this.epgDate.isSame(this.time, 'day')) this.scrollToNow();
            })
        },

        generateTimeline()
        {
            let startOfDay = moment();

            startOfDay.hours(0);
            startOfDay.minutes(0);

            this.timeLine.push(startOfDay.format("HH:mm"));

            startOfDay.add(30, "m");

            // while(startOfDay.format("HH:mm") !== "00:00") {
            //     this.timeLine.push(startOfDay.format("HH:mm"));
            //     startOfDay.add(30, "m");
            // }

            for (let i = 0; i < 60; i++) {
                this.timeLine.push(startOfDay.format("HH:mm"));
                startOfDay.add(30, "m");
            }
        },

        getProgramOffset(from)
        {
            let momentFrom = moment(from);
            let minutesFromDayStart = (momentFrom.hours() * 60) + momentFrom.minutes();

            return {
                marginLeft: minutesFromDayStart * this.minuteWidth + "px"
            }
        },

        getProgramStyles(from, to)
        {
            let momentFrom = moment(from);
            let momentTo = moment(to);

            let duration = momentTo.diff(momentFrom, 'minutes');
            let minutesFromDayStart = (momentFrom.hours() * 60) + momentFrom.minutes();

            return {
                minWidth: duration * this.minuteWidth + "px",
                width: duration * this.minuteWidth + "px",
                left: minutesFromDayStart * this.minuteWidth + "px"
            }
        },

        isProgramPlaying(from, to)
        {
            let momentFrom = moment(from);
            let momentTo = moment(to);

            let result = "";

            if (moment().isBetween(momentFrom, momentTo)) {
                result = "playing";
            } else if (moment().isAfter(momentTo)) {
                result = "played";
            }

            return result;
        },

        timeLineScroll(e)
        {
            this.$refs.timeLineEl.scrollLeft = e.target.scrollLeft;
        },

        setTimeInterval()
        {
            this.$refs.timeFormatted.innerText = moment().format("H:mm:ss");

            setInterval(() => {
                this.$refs.timeFormatted.innerText = moment().format("H:mm:ss");
            }, 1000);

            setInterval(() => {
                this.setTimeDelimiterStyles();
            }, 60000);

        },

        setTimeDelimiterStyles()
        {
            let now = moment();
            let minutesFromDayStart = (now.hours() * 60) + now.minutes();
            let visibility = this.epgDate.isSame(now, 'day') ? 'visible' : 'hidden';

            this.timeDelimiterStyles = {
                left: minutesFromDayStart * this.minuteWidth + "px",
                visibility
            }
        },

        scrollToNow()
        {
            let now = moment();
            let minutesFromDayStart = (now.hours() * 60) + now.minutes();
            this.$refs.epgProgramListEl.scrollLeft = minutesFromDayStart * this.minuteWidth - (this.$refs.epgProgramListEl.offsetWidth / 3);
        },

        dragMove(e)
        {
            switch (e.type) {
                case 'mousedown':
                    this.dragMoveAvailable = true;
                    this.dragMoveX = e.clientX;
                    this.dragMoveY = e.clientY;
                    this.dragMoveClassName = "grabing";
                    this.openDetailAvailable = Date.now();
                    break;
                case 'mouseup':
                    this.dragMoveAvailable = false;
                    this.dragMoveClassName = "";
                    break;
                case 'mousemove':
                    if (!this.dragMoveAvailable) return;
                    let dragMoveX = e.clientX - this.dragMoveX;
                    let dragMoveY = e.clientY - this.dragMoveY;
                    this.dragMoveX = e.clientX;
                    this.dragMoveY = e.clientY;

                    this.$refs.epgProgramListEl.scrollLeft = this.$refs.epgProgramListEl.scrollLeft + -dragMoveX;
                    window.scroll(0, window.scrollY + -dragMoveY);

                    break;
                case 'mouseleave':
                    this.dragMoveAvailable = false;
                    this.dragMoveClassName = "";
                    break;
            }
        },

        setEpgDate(dir)
        {
            switch (dir) {
                case 'now':
                    let now = moment();
                    if (now.isSame(this.epgDate, 'day')) {
                        this.scrollToNow();
                    } else {
                        this.epgDate = moment(now);
                        this.getData(now.format("YYYY-MM-DD"));
                    }
                    break;
                case 'prev':
                    this.epgDate.subtract('1', 'd');
                    this.getData(this.epgDate.format("YYYY-MM-DD"));
                    break;
                case 'next':
                    this.epgDate.add('1', 'd');
                    this.getData(this.epgDate.format("YYYY-MM-DD"));
                    break;
            }
        },

        setStickyTrigger()
        {
            window.addEventListener('scroll', () => {
                if (window.scrollY > this.$refs.epgContainer.offsetTop) {
                    this.topBarSticky = true;
                    this.$refs.epgContainer.style.paddingTop = this.$refs.epgBar.clientHeight + 30 + "px";
                } else {
                    this.topBarSticky = false;
                    this.$refs.epgContainer.style.paddingTop = 0;
                }
            })
        },

        showDetail(program, tv)
        {
            this.programDetail = program;
            this.tvDetail = tv;

            if (this.openDetailAvailable > Date.now() - 150) {
                setTimeout(() => { $('#detailModal').modal('show') })
            }
        },

        startScrollVertical(dir)
        {
            this.scrollVerticalInterval = setInterval(() => {
                this.$refs.epgProgramListEl.scrollLeft = this.$refs.epgProgramListEl.scrollLeft + (dir === "next" ? 5 : -5);
            },10)
        },

        stopScrollVertical()
        {
            clearInterval(this.scrollVerticalInterval);
        }
    }
    ,

    mounted() {
        this.setStickyTrigger();
        this.generateTimeline();
        this.getData(this.epgDate.format("YYYY-MM-DD"));
        this.setTimeInterval();
    },

    filters: {
        time: function (val) {
            return moment(val).format("HH:mm")
        },
        timeLineDate: function (val) {
            return moment(val).format("dddd D.M.")
        },
    },

    computed: {
        orderedEpg: function () {
            return _.orderBy(this.epg, 'order')
        }
    },

    watch: {},

    template:
`
<div class="epg" v-bind:class="[topBarSticky ? 'sticky' : '', expanded ? 'expanded' : '']" ref="epgContainer">
    
    <div class="epg-bar d-flex flex-row justify-content-between align-items-center" ref="epgBar">
        <div class="epg-bar-controls">
            <button class="btn btn-epg" @click="setEpgDate('prev')" :disabled="!prevDayAvailable">{{t.prevDay[lang]}}</button>
            <button class="btn btn-epg" @click="setEpgDate('now')">{{t.now[lang]}}</button>
            <button class="btn btn-epg" @click="setEpgDate('next')" :disabled="!nextDayAvailable">{{t.nextDay[lang]}}</button>
        </div>
        <div class="d-flex flex-row align-items-center">
            <button class="btn btn-epg btn-image mr-4" @click="expanded = !expanded">
                <img v-if="expanded" src="http://c.sledujfilmbox.cz/images/design/list.svg" title="Zobrazit stručný výpis">            
                <img v-if="!expanded" src="http://c.sledujfilmbox.cz/images/design/cards.svg" title="Zobrazit podrobnější výpis">
            </button>
            <div class="d-none d-sm-block epg-bar-time" ref="timeFormatted"></div>
        </div>
    </div>
    
    <div class="epg-timeline d-flex flex-row">
        <div class="epg-timeline-date d-flex justify-content-end"><span class="align-self-center">{{epgDate|timeLineDate}}</span></div>
        <div class="epg-timeline-wrapper d-flex flex-row" ref="timeLineEl">
            <div @mousedown="startScrollVertical('prev')"
                 @touchstart="startScrollVertical('prev')"
                 @touchend="stopScrollVertical()"
                 @mouseup="stopScrollVertical()"
                 @mouseleave="stopScrollVertical()"
                 class="epg-timeline-control epg-timeline-control-prev">
                <svg fill="none" height="30" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="30" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <div v-for="hour in timeLine" class="epg-timeline-item">{{hour}}</div>
            <div @mousedown="startScrollVertical('next')"
                 @touchstart="startScrollVertical('next')"
                 @touchend="stopScrollVertical()"
                 @mouseup="stopScrollVertical()"
                 @mouseleave="stopScrollVertical()"
                 class="epg-timeline-control epg-timeline-control-next">
                <svg fill="none" height="30" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="30" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
        </div>     
    </div>
    
    <div class="epg-wrapper d-flex">
        
        <div class="epg-tv-list">
            <div v-for="tv in orderedEpg" class="epg-tv-name d-flex justify-content-end align-items-center"
                 v-bind:class="mouseOverTv === tv.tv_id ? 'active' : ''">
                <!--<span class="align-self-center">{{tv.tv_name}}</span>-->
                <img v-bind:src="'http://c.sledujfilmbox.cz/files/epg/tv/' + tv.tv_id + '.png'" alt="logo" v-bind:title="tv.tv_name" class="img-responsive">
            </div>        
        </div>
        
        <div class="epg-program-list"
             ref="epgProgramListEl"            
             @scroll="timeLineScroll"
             @mousedown="dragMove"
             @mouseup="dragMove"
             @mousemove="dragMove"
             @mouseleave="dragMove"
             v-bind:class="dragMoveClassName">
            <div class="epg-time-delimiter" v-bind:style="timeDelimiterStyles"></div>
        
            <div v-for="tv in orderedEpg" class="epg-program-list-row">
                <div v-for="program in tv.data"  class="epg-program-item"
                     v-bind:style="getProgramStyles(program.od, program.do)" v-bind:class="isProgramPlaying(program.od, program.do)"
                     @click="showDetail(program, tv)"
                     @mouseenter="mouseOverTv = tv.tv_id"> 
                    <div v-if="!expanded" class="d-flex w-100 h-100 flex-column justify-content-between">
                        <div class="epg-program-item-name">{{program.nazev}}</div>
                        <div class="epg-program-item-time">{{program.od|time}} - {{program.do|time}}</div>
                    </div>
                    <div v-else class="d-flex w-100 h-100 flex-column">
                        <div>
                            <div class="epg-program-item-name">{{program.nazev}} <span v-if="program.typprg" class="badge badge-pill bg-info">{{program.typprg}}</span></div>
                            <div class="epg-program-item-time my-2">
                                {{program.od|time}} - {{program.do|time}} <span v-if="program.delka" class="delimiter-left">{{program.delka}} min.</span>
                            </div>
                            <div class="epg-program-item-desc d-flex flex-row" v-if="program.kratkypopis || program.obrazek">
                                <epg-list-image :program="program"></epg-list-image>
                                <div v-if="program.kratkypopis">
                                    <p>{{program.kratkypopis}}</p>              
                                </div>
                                <div v-else-if="!program.kratkypopis && program.dlouhypopis">
                                    <p>{{program.dlouhypopis}}</p>                            
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <epg-detail :program="programDetail" :tv="tvDetail"></epg-detail>
    
</div>
`

});
